import NoData from '../../assets/img/nodata_green.svg'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { useEffect, useState } from 'react'
import { formatDate } from '../../helpers/commons'
import {
  TypeUser,
  getUserProfile,
  selectAccessToken,
  selectNtumaAccount
} from '../../features/auth/authSlice'
import AppButton from '../elements/AppButton'
import useApiRequest from '../../helpers/api_request'
import { BASE_URL } from '../../helpers/constants'
import { showToastMessage } from '../../features/generalSlice'
import { toast } from 'react-toastify'
import { AxiosError } from 'axios'

const ProfilePage = () => {
  const dispatch = useAppDispatch()
  const ntumaAccount = useAppSelector(selectNtumaAccount)
  const [savingProfile, setSavingProfile] = useState(false)
  const userProfile = useAppSelector(state => state.auth.user)
  const [user, setUser] = useState<TypeUser | undefined>(userProfile)
  const apiRequest = useApiRequest()
  const accessToken = useAppSelector(selectAccessToken)

  const [newPin, setNewPin] = useState('')
  const [feeBearer, setFeeBearer] = useState('customer')

  const saveProfile = async () => {
    setSavingProfile(true)
    await apiRequest({
      method: 'post',
      url: BASE_URL + '/api/user/update-profile',
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        firstname: user?.firstname,
        lastname: user?.lastname,
        phone: user?.phone
      }
    })
      .then(response => {
        setSavingProfile(false)
        dispatch(
          showToastMessage({
            message: 'Profile Updated',
            type: 'success',
            position: toast.POSITION.TOP_RIGHT
          })
        )
        dispatch(getUserProfile())
      })
      .catch(error => {
        const errorResponse = error as AxiosError
        
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string
            status: string
          }
          dispatch(
            showToastMessage({
              message: data.message,
              type: 'error',
              position: toast.POSITION.TOP_RIGHT
            })
          )
        } else {
          dispatch(
            showToastMessage({
              message: 'Something went wrong',
              type: 'error',
              position: toast.POSITION.TOP_RIGHT
            })
          )
        }
        setSavingProfile(false)
      })
  }

  const createNewWalletPIN = async () => {
    if (newPin.length !== 5) {
      console.error('PIN must be exactly 5 digits.')

      toast.error('PIN must be exactly 5 digits.')

      return
    }

    if (!/^\d{5}$/.test(newPin)) {
      toast.error('PIN must contain only digits.')
      return
    }

    setSavingProfile(true)
    await apiRequest({
      method: 'post',

      url: BASE_URL + '/api/wallet/reset_pin',

      data: {
        new_pin: newPin,
        ntuma_account_id: ntumaAccount?.id
      }
    })
      .then(response => {
        setSavingProfile(false)

        

        if (response.status === 'SUCCESS') {
          dispatch(
            showToastMessage({
              message: 'New PIN set up as ' + newPin,
              type: 'success',
              position: toast.POSITION.TOP_RIGHT
            })
          )
        } else {
          toast.error('' + response.message)
        }

        dispatch(getUserProfile())
      })
      .catch(error => {
        const errorResponse = error as AxiosError
        
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string
            status: string
          }
          dispatch(
            showToastMessage({
              message: data.message,
              type: 'error',
              position: toast.POSITION.TOP_RIGHT
            })
          )
        } else {
          dispatch(
            showToastMessage({
              message: 'Something went wrong',
              type: 'error',
              position: toast.POSITION.TOP_RIGHT
            })
          )
        }
        setSavingProfile(false)
      })
  }

  useEffect(() => {
    const fetchSettings = async () => {
      if (!ntumaAccount?.id) return

      setSavingProfile(true)

      await apiRequest({
        method: 'post',

        url: BASE_URL + '/api/collections/get_fee_bearer_setting',

        data: {
          new_pin: newPin,
          ntuma_account_id: ntumaAccount?.id
        }
      })
        .then(response => {
          setSavingProfile(false)
          
          if (response.status === 'success' && response.data) {
            setFeeBearer(response.data.fee_bearer.toUpperCase())
          }
        })
        .catch(error => {
          setSavingProfile(false)
          console.error('Failed to fetch fee settings', error)
        })
    }

    fetchSettings()
  }, [ntumaAccount?.id])

  const saveFeeSettings = async () => {
    setSavingProfile(true)

    await apiRequest({
      method: 'post',
      url: BASE_URL + '/api/collections/save_fee_bearer_setting',
      data: {
        fee_bearer: feeBearer.toLowerCase(),
        ntuma_account_id: ntumaAccount?.id
      }
    })
      .then(response => {
        setSavingProfile(false)

        if (response.status === 'success') {
          dispatch(
            showToastMessage({
              message: 'Fee preference updated to ' + feeBearer,
              type: 'success',
              position: toast.POSITION.TOP_RIGHT
            })
          )
        } else {
          toast.error('' + response.message)
        }

        dispatch(getUserProfile())
      })
      .catch(error => {
        setSavingProfile(false)
        toast.error('Something went wrong while saving settings')
      })
  }

  return (
    <div>
      <div className='card mb-12'>
        <div className='card-body flex flex-col px-4 py-4 min-h-half-screen pb-16'>
          <div className='flex'>
            <nav className='flex justify-between ' aria-label='Breadcrumb'>
              <ol className='inline-flex items-center mb-3 sm:mb-0'>
                <li>
                  <div className='flex items-center'>
                    <h5 className=' card-title '>Personal Information</h5>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
          <div className=' w-3/4 grid grid-cols-2 mt-4  gap-3'>
            <div className=''>
              <label
                htmlFor='firstname'
                className='block text-sm font-medium text-gray-700 '
              >
                First name
              </label>
              <input
                onChange={e => {
                  if (user) {
                    setUser({
                      ...user,
                      firstname: e.target.value
                    })
                  }
                }}
                value={user?.firstname}
                type='text'
                id='firstname'
                className='form-input-2'
                placeholder=''
              />
            </div>
            <div className=''>
              <label
                htmlFor='lastname'
                className='block text-sm font-medium text-gray-700 '
              >
                Last name
              </label>
              <input
                onChange={e => {
                  if (user) {
                    setUser({
                      ...user,
                      lastname: e.target.value
                    })
                  }
                }}
                value={user?.lastname}
                type='text'
                id='lastname'
                className='form-input-2'
                placeholder=''
              />
            </div>
          </div>
          <div className=' w-3/4 grid grid-cols-2 mt-4  gap-3'>
            <div className=''>
              <label
                htmlFor='email'
                className='block text-sm font-medium text-gray-700 '
              >
                Email
              </label>
              <input
                value={user?.email}
                type='email'
                disabled
                id='name'
                className='form-input-2'
                placeholder=''
              />
            </div>
            <div className=''>
              <label
                htmlFor='phone'
                className='block text-sm font-medium text-gray-700 '
              >
                Phone number
              </label>
              <input
                onChange={e => {
                  if (user) {
                    setUser({
                      ...user,
                      phone: e.target.value
                    })
                  }
                }}
                value={user?.phone}
                type='text'
                id='phone'
                className='form-input-2'
                placeholder='+256'
              />
            </div>
          </div>
          <div className='mt-5'>
            <AppButton
              callBackFun={() => saveProfile()}
              showLoader={savingProfile}
              spinnerClass='inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black'
              className='prim-btn-1  '
              text='Save Changes'
            />
          </div>
        </div>
      </div>

      {/*     Wallet PIN*/}

      <div className='card mb-12'>
        <div className='card-body flex flex-col px-4 py-4 min-h-half-screen pb-16'>
          <div className='flex'>
            <nav className='flex justify-between ' aria-label='Breadcrumb'>
              <ol className='inline-flex items-center mb-3 sm:mb-0'>
                <li>
                  <div className='flex items-center'>
                    <h5 className=' card-title '>Ntuma Wallet PIN</h5>
                  </div>
                </li>
              </ol>
            </nav>
          </div>

          <div className=' w-3/4 grid grid-cols-2 mt-4  gap-3'>
            <div className=''>
              <label
                htmlFor='phone'
                className='block text-sm font-medium text-gray-700 '
              >
                Enter PIN (5 digits)
              </label>
              <input
                type='password'
                id='phone'
                className='form-input-2 text-center'
                placeholder='- - - - -'
                maxLength={5}
                required
                pattern='[0-9]*'
                value={newPin}
                onChange={e => setNewPin(e.target.value)}
              />
            </div>
          </div>
          <div className=' w-3/4 grid grid-cols-2 mt-4  gap-3'>
            <AppButton
              callBackFun={() => createNewWalletPIN()}
              showLoader={savingProfile}
              spinnerClass='inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black'
              className='prim-btn-1  '
              text='Reset Wallet PIN'
            />
          </div>
        </div>
      </div>

      {/* Fee Bearer Settings */}
      <div className='card mb-12'>
        <div className='card-body flex flex-col px-4 py-4 min-h-half-screen pb-16'>
          <h5 className='card-title mb-6'>Transaction Fee Settings</h5>

          <div className='w-full lg:w-3/4'>
            <label className='block text-sm font-semibold text-gray-700 mb-4'>
              Who should cover the transaction charge?
            </label>

            <div className='w-3/4 grid grid-cols-2 mt-4  gap-3'>
              {/* Customer Option */}
              <div
                onClick={() => setFeeBearer('CUSTOMER')}
                className={`cursor-pointer p-4 border-2 rounded-xl transition-all ${
                  feeBearer === 'CUSTOMER'
                    ? 'border-prim-yellow bg-yellow-50'
                    : 'border-gray-100'
                }`}
              >
                <div className='flex items-center justify-between'>
                  <span className='font-bold text-gray-900'>Customer Pays</span>
                  <input
                    type='radio'
                    checked={feeBearer === 'CUSTOMER'}
                    readOnly
                    className='accent-black'
                  />
                </div>
                <p className='text-xs text-gray-500 mt-1'>
                  A charge of 3% is added to the total. You receive the full amount.
                </p>
              </div>

              {/* Business Option */}
              <div
                onClick={() => setFeeBearer('BUSINESS')}
                className={`cursor-pointer p-4 border-2 rounded-xl transition-all ${
                  feeBearer === 'BUSINESS'
                    ? 'border-prim-yellow bg-yellow-50'
                    : 'border-gray-100'
                }`}
              >
                <div className='flex items-center justify-between'>
                  <span className='font-bold text-gray-900'>Business Pays</span>
                  <input
                    type='radio'
                    checked={feeBearer === 'BUSINESS'}
                    readOnly
                    className='accent-black'
                  />
                </div>
                <p className='text-xs text-gray-500 mt-1'>
                  A charge of 3% is deducted from your credit. Customer pays base amount.
                </p>
              </div>
            </div>
          </div>

          <div className='w-3/4 grid grid-cols-2 mt-4  gap-3'>
            <AppButton
              callBackFun={() => saveFeeSettings()}
              showLoader={savingProfile}
              spinnerClass='inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black'
              className='prim-btn-1  '
              text='Set charge fee bearer'
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default ProfilePage
